var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigateDownLarge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21c0 11.59798 9.40202 21 21 21s21-9.40202 21-21S32.59798 0 21 0 0 9.40202 0 21zm2.04878 0C2.04878 10.53353 10.53353 2.04878 21 2.04878S39.95122 10.53353 39.95122 21 31.46647 39.95122 21 39.95122 2.04878 31.46647 2.04878 21zm13.41283-2.58007c-.39978-.40032-1.04839-.40074-1.4487-.00096-.40032.39978-.40075 1.0484-.00096 1.4487l6.48821 6.4968 6.33017-6.50632c.39452-.4055.38562-1.05405-.01988-1.44857s-1.05405-.38562-1.44857.01988l-4.88078 5.0166-5.01949-5.02613z",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigateDownLarge);
export default __webpack_public_path__ + "static/media/navigateDownLarge.eb06f686.svg";
export { ForwardRef as ReactComponent };